namespace $ {

	/** Distinguish an empty land from an unapplied first remote response. */
	export class $shm_hitalama_map_history_storage_ready extends $mol_object {
		@ $mol_mem_key
		private static loading( pawn: $giper_baza_pawn ) { return { promise: new $mol_promise_blocker<void>() } }

		@ $mol_mem_key
		static settled( pawn: $giper_baza_pawn ) {
			pawn.units()
			const land = pawn.land(), yard = pawn.$.$giper_baza_glob.yard()
			// Baza faces are a plain Map. A later Gift or a Sand under another
			// head can advance the local clock without changing pawn.units().
			// Observe only raw metadata dictionaries of this bounded land: no
			// payload decoding, signing, persistence or extra land discovery.
			land._gift?.size
			for( const peers of land._sand?.values() ?? [] ) {
				for( const units of peers.values() ) units.size
			}
			const ports = yard.masters()
			if( !ports.length ) return true
			const faces = ports.map( port=> yard.face_port_land([ port, land.link() ]) )
			if( !faces.some(Boolean) || faces.some( face=> face && [...face].some( ([peer,remote])=> {
				const local = land.faces.get(peer)
				return !local || local.time_tick < remote.time_tick
			}) ) ) $mol_fail_hidden( this.loading(pawn).promise )
			return true
		}
	}

}
